module.exports = __webpack_public_path__ + "static/media/National Housing Preservation Database template.52a665c2.xlsx";